<template>
	<van-popup
		:show="show"
		position="bottom"
		round
		:style="{ height: '70%' }"
		@update:show="handlePopupVisibility"
	>
		<div class="work-location-popup">
			<div class="popup-header">
				<span>选择工作地点</span>
				<van-icon name="cross" @click="handlePopupVisibility(false)" />
			</div>
			<div class="popup-search">
				<van-icon name="search" class="popup-search-icon" />
				<input
					v-model.trim="keyword"
					type="text"
					placeholder="请输入城市名称搜索"
				/>
				<van-icon
					v-if="keyword"
					name="clear"
					class="popup-clear-icon"
					@click="clearKeyword"
				/>
			</div>
			<div class="popup-list">
				<button
					v-for="option in filteredOptions"
					:key="option.value"
					class="popup-option"
					:class="{ active: tempSelectedValues.includes(option.value) }"
					type="button"
					@click="toggleValue(option.value)"
				>
					<span>{{ option.text }}</span>
					<van-icon v-if="tempSelectedValues.includes(option.value)" name="success" />
				</button>
				<div v-if="filteredOptions.length === 0" class="popup-empty">未搜索到对应城市</div>
			</div>
			<div class="popup-actions">
				<button class="popup-action plain" type="button" @click="resetSelection">重置</button>
				<button class="popup-action primary" type="button" @click="confirmSelection">确定</button>
			</div>
		</div>
	</van-popup>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed, ref, watch } from "vue";

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	options: {
		type: Array,
		default: () => [],
	},
	selectedValues: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(["update:show", "confirm"]);

const keyword = ref("");
const tempSelectedValues = ref([]);

const filteredOptions = computed(() => {
	const currentKeyword = keyword.value.toLowerCase();
	return props.options.filter((item) => {
		return !currentKeyword || item.text.toLowerCase().includes(currentKeyword);
	});
});

const syncSelection = () => {
	tempSelectedValues.value = [...props.selectedValues];
};

watch(
	() => props.show,
	(value) => {
		if (value) {
			syncSelection();
			return;
		}
		keyword.value = "";
	}
);

watch(
	() => props.selectedValues,
	() => {
		if (props.show) {
			syncSelection();
		}
	},
	{ deep: true }
);

const handlePopupVisibility = (value) => {
	emit("update:show", value);
	if (!value) {
		keyword.value = "";
	}
};

const toggleValue = (value) => {
	if (tempSelectedValues.value.includes(value)) {
		tempSelectedValues.value = tempSelectedValues.value.filter((item) => item !== value);
		return;
	}
	tempSelectedValues.value = [...tempSelectedValues.value, value];
};

const resetSelection = () => {
	tempSelectedValues.value = [];
	emit("confirm", []);
	handlePopupVisibility(false);
};

const clearKeyword = () => {
	keyword.value = "";
};

const confirmSelection = () => {
	emit("confirm", [...tempSelectedValues.value]);
	handlePopupVisibility(false);
};
</script>

<style lang="scss" scoped>
.work-location-popup {
	height: 100%;
	padding: 24rem 24rem 24rem;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.popup-header {
	display: flex;
	align-items: center;
	justify-content: center;
	// justify-content: space-between;
	font-size: 30rem;
	color: #333;
	font-weight: 600;
	flex-shrink: 0;
	position: relative;
	
	.van-icon {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
	}
}

.popup-search {
	margin-top: 20rem;
	height: 64rem;
	border-radius: 10rem;
	background: #f5f5f5;
	display: flex;
	align-items: center;
	padding: 0 18rem;
	box-sizing: border-box;
	flex-shrink: 0;

	input {
		flex: 1;
		border: none;
		outline: none;
		font-size: 26rem;
		background: transparent;
		color: #333;
	}
}

.popup-search-icon,
.popup-clear-icon {
	font-size: 28rem;
	color: #999;
}

.popup-search-icon {
	margin-right: 10rem;
}

.popup-clear-icon {
	margin-left: 10rem;
}

.popup-list {
	margin-top: 20rem;
	flex: 1;
	overflow-y: auto;
	min-height: 0;
}

.popup-option {
	width: 100%;
	min-height: 88rem;
	padding: 0 20rem;
	border: none;
	border-bottom: 1px solid #f0f0f0;
	background: #fff;
	text-align: left;
	font-size: 28rem;
	color: #333;
	display: flex;
	align-items: center;
	justify-content: space-between;

	&.active {
		color: #005a57;
		font-weight: 600;
	}
}

.popup-actions {
	display: flex;
	gap: 16rem;
	margin-top: 24rem;
	flex-shrink: 0;
}

.popup-action {
	flex: 1;
	height: 72rem;
	border-radius: 12rem;
	font-size: 28rem;
	border: none;

	&.plain {
		background: #f2f2f2;
		color: #555;
	}

	&.primary {
		background: #005a57;
		color: #fff;
	}
}

.popup-empty {
	padding: 60rem 0;
	text-align: center;
	font-size: 26rem;
	color: #999;
}
</style>